import styled from "styled-components"

export const ContactUsWrapper = styled.div`
    font-feature-settings: 'clig' off, 'liga' off;
    font-family: var(--general-font-family);
    font-style: normal;
    background: var(--White-100, #FFF);
`

export const ContactUsContainer = styled.div`
    width: 238px;
    height: 249px;
    color: var(--font-color-blue002e5c);
  
    font-size: var(--general-label-font-size);
    font-weight: var(--general-label-font-weight);
    line-height: 13px; 
 div{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
 }
`
export const ContactUsText = styled.div`
    height: 56px;
    background-color: #2555EF;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--font-color-white);
    font-size: var(--general-sub-header-font-size);
    
    font-weight: var(--general-sub-header-font-weight);
    line-height: 13px;
`
export const Phone = styled.div`
    margin-bottom: 38px;
    margin-top: 25px;
    a{
        padding-top:12px;
        cursor: pointer;
        color:var(--font-color-black);
    }
  
`
export const Email = styled.div`
 span{
        padding-top:12px;
        cursor: pointer;
    }
`

export const Wrapper = styled.div`
 cursor: pointer;
    display:flex;
    top: ${(props) => (props.isMobile ? '21px' : '10px')};
    right: ${(props) => (props.isMobile ? '85px' : '72px')};
    position: fixed;
    /* overflow-x: scroll; */
    justify-content: flex-end;
div{
    background-color: #fff;
    border-radius: 50%;
    padding: 2px;
    }
`
export const ContactUsContent = styled.div`
    position: absolute;
    right: 6%;
    bottom: -22%;
`